import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CabListingCardHeaderUI from "../../../../../stories/components/cars/ResultsPage/CabListingCardHeader/CabListingCardHeaderUI";
import CabListItemUI from "../../../../../stories/components/cars/ResultsPage/CabListItem/CabListItemUI";
import OtherCabOptionsUI from "../../../../../stories/components/cars/ResultsPage/OtherCabOptions/OtherCabOptionsUI";
import {
  commonSelector,
  dispatchSelector,
  seoFilteredVehicleDataSelector,
} from "../../redux/selector";
import * as S from "./AlternateListing.styles";
import useNavigate from "../../../../hooks/useNavigate";
import { sourceSelector, destinationSelector } from "../../../../common/redux/selector";
import { UPDATE_PAYDATA, UPDATE_SELECTED_CAB } from "../../redux/seo-action-types";

interface IListing {}

const Listing: React.FC<IListing> = () => {
  const dispatch = useDispatch();
  const dispatchSearchId = useSelector(dispatchSelector);
  const filtered_vehicle_data = useSelector(seoFilteredVehicleDataSelector);
  const source = useSelector(sourceSelector);
  const destination = useSelector(destinationSelector);
  const commonData = useSelector(commonSelector)
  const [showMore, toggleMore] = useState({});
  const [navigateTo] = useNavigate();

  const naviagteToReview = useCallback(
    (selectedCab) => {
      dispatch({
        type: UPDATE_PAYDATA,
        paydata: {}
      });
      dispatch({
        type: UPDATE_SELECTED_CAB,
        selectedCab: { ...selectedCab, dispatchSearchId },
      });
      navigateTo("seo-to-review");
    },
    [dispatchSearchId]
  );

  const toggleFn = useCallback(
    (index) => {
      const updateMore = { ...showMore, [index]: !showMore[index] };
      toggleMore(updateMore);
    },
    [showMore]
  );

  if (filtered_vehicle_data?.length > 0) {
    return (
      <>
        <h2 className="font18 fontMedium rubik appendTop28 appendBottom20">{`Other Cab Options from ${source?.name} to ${destination?.name}`}</h2>
        {filtered_vehicle_data?.map(({ t_c, c_d = [] }, key) => {
          return (
            <S.ListingCard key={key}>
              <CabListingCardHeaderUI {...t_c} key={`clKey${key}`} />
              {c_d.map((item, index) => {
                if (index >= 1 && !showMore[key]) return null;
                return (
                  <CabListItemUI
                    {...item}
                    itemKey={item?.key}
                    key={`clItem${index}`}
                    t_c={t_c}
                    c_d={c_d}
                    position={key}
                    commonData={commonData}
                    naviagteToReview={naviagteToReview}
                  />
                );
              }) || null}
              <OtherCabOptionsUI
                {...t_c}
                showMore={!!showMore[key]}
                toggleFn={toggleFn}
                index={key}
                cdLen={c_d?.length}
              />
            </S.ListingCard>
          );
        }) || []}
      </>
    );
  }
  return null
};

export default React.memo(Listing);
